import { withEditableArea } from '@trendkite/ui';

import EditStoryBacklinks from './EditStoryBacklinks';
import StoryBacklinksDisplay from './StoryBacklinksDisplay';

export default withEditableArea(StoryBacklinksDisplay, EditStoryBacklinks);
